import { Container, Row } from "reactstrap";
import Setup from "./Setup";
import BreadCrumb from "Components/Common/BreadCrumb";
import { withTranslation } from "react-i18next";
import { useCompanyName } from 'Components/Common/ThemeSettings/themeutitlity';

const index = (props: any) => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
            <BreadCrumb title={props.t("Apps setup")} pageTitle={props.t("Apps setup")} icon={"ri-book-open-line"} />
            <Setup />
        </Container>
      </div>
    </>
  );
};

export default withTranslation()(index);
